import template from './taskQuickButtons.html';
import controller from './TaskQuickButtonsController';

function taskQuickButtons() {
  return {
    restrict: 'E',
    template,
    scope: {
      task: '=',
      assigneduser: '=assigneduser',
      username: '=username',
      status: '=status'
    },
    controller: 'TaskQuickButtonsController'
  };
}

export default function (ngModule) {
  ngModule.directive('taskQuickButtons', taskQuickButtons);
  controller(ngModule);
}
